/**
 * Format admin role for display.
 * e.g., "super_admin" -> "Super Admin"
 */
export function formatRole(role: string | null | undefined): string {
  if (!role) return ''
  return role
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}
